import React, { useEffect, useRef } from "react";
import Typed from "typed.js";
import About from "./About";
import Tosin from "./images/tboy.JPG";
import { useNavigate } from "react-router-dom";
function Home() {
  const el = useRef(null);
  const typed = useRef(null);
  useEffect(() => {
    const options = {
      strings: ["Hi,My name is Adetunji Tosin Kayode."],
      typeSpeed: 70,
    };
    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, []);

  return (
    <div className="cont">
      <div className="top">
        <center>
          <span
            className="hi"
            ref={el}
            style={{
              fontSize: "18px",
              textTransform: "capitalize",
              // fontFamily: "sans-serif",
              lineHeight: "1",
              letterSpacing: "1px",
              color: "white",
              fontWeight: "bolder",
              position: "relative",
              top: "90px",
              padding: "10px",
            }}
          ></span>
          {/* <div className="circle">
            <img
              src={Tosin}
              style={{ width: "20%", position: "relative", top: "130px" }}
            />
          </div> */}
          <p
            style={{
              color: "white",
              position: "relative",
              top: "180px",
              fontWeight: "bolder",
            }}
            className="intro"
          >
            I am frontend developer focus on building <br /> an easy to use and
            user-friendly web app applications.
          </p>
          <br />
          <div style={{ position: "relative", top: "150px" }}>
            <button className="btn btn-primary" style={{ width: "30%" }}>
              Hire Me
            </button>

            <button
              className="btn btn-secondary"
              style={{ width: "30%", position: "relative", left: "30px" }}
            >
              Resume
            </button>
          </div>
          <About />
        </center>
      </div>
    </div>
  );
}

export default Home;
